/* eslint-disable react/function-component-definition */
import React, { useContext, PropsWithChildren } from 'react';
import { useBrooklynUserJwt } from './useBrooklynUserJwt';

type ContextValue = ReturnType<typeof useBrooklynUserJwt>;
type Props = Parameters<typeof useBrooklynUserJwt>[0];
export const BrooklynUserJwtContext = React.createContext<ContextValue | null>(null);

export const BrooklynUserJwtProvider: React.FC<PropsWithChildren<Props>> = ({
  children,
  ...rest
}) => {
  const value = useBrooklynUserJwt(rest);

  return (
    <BrooklynUserJwtContext.Provider value={value}>{children}</BrooklynUserJwtContext.Provider>
  );
};

export const useBrooklynUserJwtContext = () => {
  const value = useContext(BrooklynUserJwtContext);
  if (!value) throw new Error('Missing BrooklynUserJwtContext Provider');
  return value;
};
